<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="text-center" style="color: white">{{ $t('joinWorkspaceComplete') }}</h2>
    <p slot="desc" class="desc text-center">
      <span v-if="passedType === 'request'">{{ $t('joinWorkspaceCompleteDesc') }}</span>
      <span v-else-if="passedType === 'invite' && inviteCnt !== '0'">{{ $t('inviteTeammatesCompleteDesc') }}</span>
    </p>
    <p slot="content" class="small text-center mt-5" v-if="passedType === 'invite'">
      {{ $t('msgRedirectDesc') }}
    </p>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { mapGetters } from 'vuex'

export default {
  name: 'CompleteWorkspace',
  components: {
    Layout,
  },
  props: ['passedType', 'inviteCnt', 'passedWsDomain'],
  async created() {
    if (!this.passedType) {
      this.$router.replace({ name: 'Workspace' })
      return false
    }

    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: this.passedType === 'invite' ? '워크스페이스 생성 완료' : '워크스페이스 가입 요청 완료',
        firebase_screen_class: this.passedType === 'invite' ? 'Create' : 'Join',
      },
    })
  },
  mounted() {
    if (this.passedType === 'invite') {
      setTimeout(() => {
        // this.$router.replace({ name: 'Meeting', params: { wsDomain: this.$store.getters.userWsList[0].wsDomain } })
        this.moveWorkspace()
      }, 3000)
    }
  },
  methods: {
    async moveWorkspace() {
      await this.$store.dispatch(
        'setSelectedWsInfo',
        this.userWsList.find((ws) => ws.wsDomain === this.passedWsDomain)
      )
      await this.$router.replace(`/${this.passedWsDomain}/my`).catch(() => {})
    },
  },
  computed: {
    ...mapGetters(['userWsList']),
  },
}
</script>

<style scoped>
.small {
  font-size: 14px;
  line-height: 32px;
  color: #999;
}
</style>
